import { UNION } from './src/constants';
import { mapFilterModelToCriterias } from './mapFilterModelToCriterias';

/**
 * Devuelve un filterEdiwin
 *
 * @param {object} filterModel El filterModel
 * @param {string} orderBy el orderBy ej: 'campo desc, otro' ('asc' por defecto)
 * @param {string} groupBy el groupBy
 * @returns
 */
export function mapFilterModelToFilterEdiwin(filterModel, orderBy, groupBy) {
  const filter = {
    filterCriteria: {
      children: [],
      criteria: null,
      union: null,
    },
    orderBy,
    groupBy,
  };

  const criterias = mapFilterModelToCriterias(filterModel);

  const last = criterias.length - 1;

  criterias.forEach((criteria, index) => {
    const filterCriteria = {
      children: null,
      criteria,
      union: last === index ? null : UNION.AND,
    };
    filter.filterCriteria.children.push(filterCriteria);
  });
  return filter;
}
